import { useMemo, useState } from "react";
import PageHeader from "@/components/feature/PageHeader";
import ContentCard from "@/components/base/ContentCard";
import Pagination from "@/components/base/Pagination";
import { useSEO } from "@/hooks/useSEO";
import { brandStories, brandCategories } from "@/mocks/content";
import { filterItems, sortByDateDesc } from "@/utils/content";

const PAGE_SIZE = 6;

export default function Brand() {
  useSEO({
    title: "品牌介绍 - 白峰美羽",
    description: "了解白峰美羽的品牌历史、文化、理念与使命，探索十六年沉淀下的东方质感审美。",
    keywords: "白峰美羽,品牌介绍,品牌历史,品牌文化,品牌使命",
  });

  const [category, setCategory] = useState("全部");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const items = filterItems(brandStories, category);
    return sortByDateDesc(items);
  }, [category]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const current = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleCategoryChange = (cat: string) => {
    setCategory(cat);
    setPage(1);
  };

  return (
    <>
      <PageHeader
        eyebrow="BRAND STORY"
        title="品牌介绍"
        description="从起点到使命，白峰美羽把十六年的坚持拆解成一个个可以被讲述的专题，欢迎慢慢阅读。"
        crumbs={[{ label: "首页", path: "/" }, { label: "品牌介绍" }]}
      />

      <section className="max-w-site mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-wrap gap-2 mb-8">
          {brandCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => handleCategoryChange(cat)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                category === cat
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <h2 className="sr-only">品牌专题列表</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {current.map((item) => (
            <ContentCard key={item.id} item={item} />
          ))}
        </div>

        <Pagination page={page} totalPages={totalPages} onChange={setPage} />
      </section>
    </>
  );
}